/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@sa/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private authService = inject(MsalService);

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const excludedUrl = environment.apiConfig.uri;
        const functionAppUrl = environment.functionAppURL;
        if (request.url.includes(excludedUrl)) {
            return next.handle(request);
        }
        let isGraphApi = false;
        try {
            const parsedUrl = new URL(request.url, window?.location?.origin || undefined);
            isGraphApi = parsedUrl.host === 'graph.microsoft.com';
        } catch {
            isGraphApi = false;
        }
        const scopes = isGraphApi
            ? environment.msalConfig.scopes
            : environment.apiConfig.apiScope;
        const account = this.authService.instance.getActiveAccount();
        if (account) {
            return from(
                this.authService.instance.acquireTokenSilent({
                    scopes: scopes,
                })
            ).pipe(
                switchMap(response => {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${response.accessToken}`,
                        },
                    });
                    return next.handle(request);
                }),
                catchError((error: any) => {
                    // Handle AADSTS65001 (consent required)
                    if (
                        error &&
                        error.errorCode === 'invalid_grant' &&
                        error.errorMessage &&
                        error.errorMessage.includes('AADSTS65001')
                    ) {
                        // Fallback to interactive consent
                        return from(
                            this.authService.instance.acquireTokenPopup({
                                scopes: scopes,
                            })
                        ).pipe(
                            switchMap((popupResponse: any) => {
                                request = request.clone({
                                    setHeaders: {
                                        Authorization: `Bearer ${popupResponse.accessToken}`,
                                    },
                                });
                                return next.handle(request);
                            }),
                            catchError((popupError: any) => {
                                return throwError(() => popupError);
                            })
                        );
                    }
                    return throwError(() => error);
                })
            );
        }
        return next.handle(request);
    }
}
